import { render, staticRenderFns } from "./GameNewCopy.vue?vue&type=template&id=777ecca4&scoped=true"
import script from "./GameNewCopy.vue?vue&type=script&lang=js"
export * from "./GameNewCopy.vue?vue&type=script&lang=js"
import style0 from "./GameNewCopy.vue?vue&type=style&index=0&id=777ecca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777ecca4",
  null
  
)

export default component.exports